import './../css/slidemenu.scss'
import 'lazysizes';
import Modal from "./modal";
import Slider from "./slider_v2";
import SlidingMenu from "./slidemenu";
import PinchZoom from "./pinch-zoom";
import './favorites'
import './form_validate'

const isIosDevice = (/iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);

window.Modal = Modal;
window.SlidingMenu = SlidingMenu;
window.Slider = Slider;
window.PinchZoom = PinchZoom;
window.pollFragments = null;
window.fragments = {individual: [], groups: {}};
window.isIos = isIosDevice;
window.isHuman = new Promise(function(resolve) {
    var isHuman = null;
    var req;
    try {
        var s = localStorage.getItem('isHuman');
        isHuman = s !== null ? parseInt(s) : null;
    } catch (e) {
        isHuman = null
    }
    if (isHuman !== null) {
        resolve(isHuman);
        return;
    }
    req = new XMLHttpRequest();
    req.open('GET', window.routes.bots, true);
    req.send(null);
    req.onreadystatechange = function() {
        var d = {isHuman: false};
        if (this.status === 200 && this.readyState === 4) {
            try {d = JSON.parse(this.response);} catch (e) {}
            isHuman = d.isHuman;
            try {
                localStorage.setItem('isHuman', isHuman ? '1' : '0');
            } catch (e) {}
            resolve(isHuman);
        }
    };
    req.onerror = function() {
        resolve(isHuman);
    }
})
window.geoLocate = new Promise(function(resolve) {
    var location;
    try {
        location = JSON.parse(sessionStorage.getItem('location'));
    } catch (e) {
        location = null
    }

    if (location) {
        resolve(location);
        return;
    }

    window.isHuman.then(function(status) {
        if (!status) {
            resolve(location);
            return;
        }
        var req = new XMLHttpRequest();
        req.open('GET', 'https://geolocator.dichisar.workers.dev/', true);
        req.send(null);
        req.onreadystatechange = function() {
            if (this.status !== 200 || this.readyState !== 4) {
                return;
            }
            try {
                location = JSON.parse(this.response);
            } catch (e) {
                location = null;
            }

            try {
                sessionStorage.setItem('location', JSON.stringify(location));
            } catch (e) {}
            resolve(location);
        };
        req.onerror = function() {
            resolve(location);
        }
    })
})
window.setLocationCookie = function() {
    return new Promise(function(resolve) {
        let hasLoc;
        try {
            hasLoc = JSON.parse(sessionStorage.getItem('hasLocation')) || null;
        } catch (e) {
            hasLoc = null;
        }
        if (hasLoc) {
            resolve();
        }
        if (!hasLoc) {
            window.geoLocate.then(function(location) {
                $.getJSON(routes.shipping.location, location ? {location: location} : {}, function() {
                    try {
                        sessionStorage.setItem('hasLocation', '1');
                    } catch (e) {}
                    resolve();
                });
            })
        }
    })
}
window.isHuman.then(function(status) {
    if (!status) return;
    window.asyncScripts.forEach(function(src) {
        if (typeof src === 'function') {
            src();
            return true;
        }

        var e = document.createElement('script');
        e.async=true;
        e.src=src;
        e.onload=function() {
            e.loaded = true;
        }
        document.body.appendChild(e);
    })
})

var $fragments = $('.fragment');
var $cartBtn = $('#cart-button, #main-menu-cart-button');
var $preloader = $('#preloader');
var $floatingError = $('#floating-error-modal');

var getRandomId = function() {
    return '_' + Math.random().toString(20).substr(2, 6);
}
window.getRandomId = getRandomId;
window.preloader = function(show) {
    if (show) {
        if (!$body.hasClass('has-preloader')) {
            $body.addClass('has-preloader');
            $preloader.show()
        }
    } else {
        $preloader.hide()
        $body.removeClass('has-preloader');
    }
}
window.updateFragment = function(name, callback, silent) {
    if (!silent) {
        preloader(1);
    }

    if (window.pollFragments) {
        clearTimeout(pollFragments);
    }
    let $fragment = $fragments.filter('[data-fragment="' + name + '"]');
    let group = $fragment.data('group');

    if (!group) {
        window.fragments.individual.push({$el: $fragment, name: name, callback: callback});
    } else {
        if (window.fragments.groups[group] === undefined) {
            window.fragments.groups[group] = {
                src: $fragment.data('src'),
                fragments: {}
            };
        }

        window.fragments.groups[group].fragments[name] = {$el: $fragment, callback: callback};
    }

    window.pollFragments = setTimeout(() => {
        let promises = [];

        for (let i = 0; i < window.fragments.individual.length; i++) {
            let fragment = window.fragments.individual[i];
            promises.push(new Promise(resolve => {

                $.get(fragment.$el.data('src'), function (response) {
                    fragment.$el.children().remove();
                    fragment.$el.html(response)
                        .find('.icon').icon().end()
                        .find('form.needs-validation').formValidate();

                    if (typeof fragment.callback === 'function') {
                        fragment.callback(fragment.$el);
                    }
                    resolve()
                })
            }))
        }

        let groupKeys = Object.keys(window.fragments.groups);
        if (groupKeys.length > 0) {
            for (let grName in window.fragments.groups) {
                promises.push(new Promise(resolve => {
                    let group = window.fragments.groups[grName];
                    let fragments = Object.keys(group.fragments);
                    if (fragments.length) {
                        $.getJSON(group.src, {fragments: fragments}, function(response) {
                            for (let fr in response) {
                                let fragment = group.fragments[fr];

                                if (!fragment) {
                                    continue;
                                }

                                fragment.$el.children().remove();
                                fragment.$el.html(response[fr])
                                    .find('.icon').icon().end()
                                    .find('form.needs-validation').formValidate();

                                if (typeof fragment.callback === 'function') {
                                    fragment.callback(fragment.$el);
                                }
                                resolve()

                            }
                        })
                    }
                }))
            }
        }

        Promise.all(promises).finally(() => {
            window.fragments.individual = [];
            window.fragments.groups = {};
            window.pollFragments = null;
            if (!silent) {
                preloader(0);
            }
        })
    }, 300)
}
window.updateCartButton = function(data) {
    if (data && data.items_count > 0) {
        $cartBtn.attr('data-tag', data.items_count);
        $cartBtn.find('.items').html(data.items);
        $cartBtn.find('.total').html(data.total);
    } else {
        $cartBtn.removeAttr('data-tag');
        $cartBtn.find('.items').html('0');
        $cartBtn.find('.total').html('0');
    }

}
window.showError = function (message, callback) {
    $floatingError
        .find('.text').html(message).end()
        .modal('show');

    if (callback) {
        $floatingError.one('modal:hidden', callback)
    }
}
if (!window.$body) {
    window.$body = $('body');
}

$.fn.slider = function (options) {
    return $(this).each(function() {
        var $el = $(this);
        var $slides = $el.find('.slider-frame').children();
        var slides = $slides.length - 1;
        var slider = new Slider(this, options);
        var $videoSlides = $slides.filter('.video-slide');

        this.slider = slider;

        if ($videoSlides.length > 0) {
            var firstVideoSlideIndex = $videoSlides.first().index();
            var $videoTooltips = $el.find('.video-tooltip');

            $el.find('.slider-bullets i').eq(firstVideoSlideIndex).addClass('video-indicator');
            $el.addClass('has-video');
            $el.on('slide', '.slide', function () {
                var $slide = $(this);
                $el.toggleClass('is-showing-video', $slide.is('.video-slide'));
                if ($videoTooltips.length > 0 && ($slide.index() >= firstVideoSlideIndex || $slide.is('.video-slide'))) {
                    $el.find('.video-tooltip').css({visibility: 'hidden', opacity: 0});
                    $videoTooltips = [];
                }
            })
            if ($videoTooltips.length > 0) {
                $el.one('click', '.video-tooltip', function() {
                    slider.slideTo(firstVideoSlideIndex, true);
                    $(this).css({visibility: 'hidden', opacity: 0});
                    return false;
                })
            }
        }

        if (options && options.autoSlide) {
            var pause = false;

            $el
                .on('mouseenter touchstart', function () {
                    pause = true;
                })
                .on('mouseleave', function () {
                    pause = false;
                })

            setInterval(function() {
                if (pause) {
                    return;
                }

                var nextSlide = slider.currentSlide() + 1;
                if (nextSlide > slides) {
                    nextSlide = 0;
                }
                slider.slideTo(nextSlide, true)
            }, options.autoSlide);
        }
    })
}
$.fn.icon = function() {
    $(this).filter('[data-icon]').each(function() {
        var $el = $(this);
        $el.html(`<svg class="feather"><use xlink:href="${routes.feather}#${$el.data('icon')}"/></svg>`);
    })
    return this;
}
$.fn.modal = function (command) {
    var $el = $(this);
    if (!$el.length) {
        return this;
    }
    if (!$el.data('modal')) {
        var isPopup = $el.is('.modal-popup');
        $el.data('modal', new Modal($el[0], Object.assign(
            $el.data('modal-options')  || {},
            {ios: isIosDevice, fullscreen: !isPopup}
        )));

        // if (isPopup && isIosDevice) {
        //     $el.on('touchmove', function(e) {
        //         e.preventDefault();
        //         e.stopImmediatePropagation();
        //         return false;
        //     });
        // }

        if ($el.hasClass('sliding-menu')) {
            $el.data('slidingMenu', new SlidingMenu($el[0], $el.data('slidingMenuOptions') || {}))
        }
    }
    if (command) {
        window.requestAnimationFrame(function() {
            $el.data('modal')[command]();
        })
    }
    return this;
}
$.fn.fakeFocus = function() {
    var $input = $(this);
    var $fakeInput = $("<input type='text' />").css({
        position: "absolute",
        width: $input.outerWidth(),
        height: 0,
        opacity: 0,
    });
    return $fakeInput.prependTo('body').focus();
}

if ($cartBtn.length > 0){
    $.getJSON(routes.cartMetadata, function(data) {
        updateCartButton(data);
    });
}

var modalState = {
    manual: {
        close: false,
    },
    navigation: {
        close: false,
    }
}
$(document)
    .on('click', '.pristine-error.help', function() {
        $(this).closest('.field').find('input, select').focus();
        return false;
    })
    .on('click', 'a.is-xhr', function() {
        var modalId = getRandomId();
        var $el = $(this);
        var href = $(this).attr('href');
        preloader(1);
        $.get(href, function (response) {
            var $modal = $(response);
            $modal.find('.icon').icon();
            $modal.find('form.needs-validation').formValidate();
            $modal.attr('id', modalId)
            $modal.appendTo('body');
            $body
                .find('a.is-xhr[href="' + href + '"]')
                .attr('href', '#' + modalId)
                .addClass('modal-toggle')
                .removeClass('is-xhr');
            setTimeout(function() {
                preloader(0);
                $modal.modal('show');
            }, 200)
        })
        return false;
    })
    .on('click', 'a.modal-toggle', function(){
        var $el = $(this);
        var $modal = $($el.attr('href'));

        if (!$el.is('.is-disabled')) {
            if ($el.is('.modal-focus-input')) {
                var $input = $modal.find('input:not([type="hidden"])');
                var $fakeInput = $input.fakeFocus();

                $modal.one('modal:show', function() {
                    var val = $input.val();
                    $input.focus();
                    $fakeInput.remove();
                    $input.val('');
                    if (val.length) {
                        $input.val(val);
                    }
                });
            } else if ($el.data('tab')) {
                $modal.data('tab', $el.data('tab'));
                $modal.find('a[data-tab="' + $el.data('tab') + '"]').click();
            }
            $modal.modal('show');
        }
        return false;
    })
    .on('click', '[data-collapse]', function(e) {
        if (!$(e.target).is('[data-prevent-default]')) {
            $(this).toggleClass('is-collapsed');
            return false;
        }
    })
    .on('click', '[data-href]', function(e) {
        var $el = $(this);
        e.preventDefault();
        e.stopImmediatePropagation();
        if ($el.data('target') === '_blank') {
            window.open($el.data('href'), '_blank');
        } else {
            preloader(1);
            location.href = $el.data('href');
        }
    })
    .on('modal:show', '.modal-page:not([data-custom-scroll])', function() {
        const section = this.querySelector('section');
        if (section) {
            section.scrollTo(0, 0);
        }
    })
    .on('modal:show', '.sliding-menu', function() {
        var list = $(this).data('slidingMenu').current();
        list.scrollTo(0, 0);
    })
    .on('modal:hidden', '.sliding-menu', function() {
        $(this).trigger('slidingmenu:modal:hidden')
    })
    .on('touchstart', 'section[data-results-section]', function() {
        $(this).prev().find('input').trigger('blur');
    })
    .on('modal:show', '.modal', function() {
        if (modalState.navigation.open) {
            return;
        }
        try {
            history.pushState({id: this.id}, null, '#' + this.id);
        } catch (e) {

        }
    })
    .on('modal:hide', '.modal', function() {
        if (modalState.navigation.close) {
            return;
        }
        modalState.manual.close = true;
        try {
            history.back();
        } catch (e) {}
    })
    .on('modal:hidden', '.modal', function() {
        modalState.manual.close = false;
        modalState.navigation.close = false;
    })

$('.icon').icon();
$('form.needs-validation').formValidate();
if (_user) {
    checkFavoriteStatus(routes.favorite.products, 'products');
    //checkFavoriteStatus(routes.favorite.shops, 'shops');
}

window.addEventListener('popstate', function(e) {
    if (modalState.manual.close || modalState.manual.open) {
        return;
    }
    if (document.documentElement.dataset.currentModal) {
        modalState.navigation.close = true;
        $('#' + document.documentElement.dataset.currentModal).modal('hide');
    }
});
window.addEventListener('beforeunload', () => { preloader(1); });
window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
        preloader(0);
    }
})
$(document).on('click', 'a:not([target="_blank"])', (e) => {
    if (e.originalEvent && !e.originalEvent.defaultPrevented) {
        preloader(1);
    }
})
if (isIosDevice) {
    document.documentElement.classList.add('is-ios')
}
$('#header-slider').slider();